import { useMutation } from "@tanstack/react-query";
import { IAssignContract, ICreateOrUpdateContract } from "../../models/Contract";
import { ContractService } from "../../services/contract.service";

export const useContractMutations = () => {
  const { mutate: createOrUpdateContract } = useMutation<any, Error, ICreateOrUpdateContract>({
    mutationFn: async (model) => ContractService.createOrUpdateContract(model),
  });

  const { mutate: assignContract } = useMutation<any, Error, IAssignContract>({
    mutationFn: async (model) => ContractService.assign(model),
  });

  return {
    createOrUpdateContract,
    assignContract,
  };
};
